import { render, staticRenderFns } from "./DTPicker.vue?vue&type=template&id=045350ce"
import script from "./DTPicker.vue?vue&type=script&lang=js"
export * from "./DTPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports